import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DatePickerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() paramDateForm: FormGroup;
  @Input() styleType: string = 'rounded';
  @Input() paramDate: string; // format: 'DD/MM/YYYY'
  @Input() label: string = 'Date'; // label personnalisé
  @Input() customClass: string = ''; // classe CSS personnalisée
  @Input() showFloatLabel = false;

  @Output() chosenDate = new EventEmitter<void>();

  dateForm: FormGroup;

  private componentDestroyed$: Subject<void> = new Subject();

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initValueChange();
  }

  // --- Init Form ---
  public initForm() {
    this.dateForm = this.fb.group({
      date: [null as Date | null, Validators.required],
    });
  }

  // --- Cancel ---

  public cancelFormsModification() {
    this.initForm();
    this.setInitialDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.paramDate) {
      this.setInitialDate();
    }
  }

  private setInitialDate() {
    if (this.paramDate) {
      const date = moment(this.paramDate, 'DD/MM/YYYY').toDate();
      this.dateForm?.get('date').setValue(date);
      this.paramDateForm.get('date').setValue(this.paramDate);
    }
  }

  private initValueChange() {
    this.dateForm
      .get('date')
      .valueChanges.pipe(debounceTime(500), takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        const date = moment(this.dateForm.value.date).format('DD/MM/YYYY');
        this.paramDateForm.get('date').setValue(date);
        if (date) this.chosenDate.emit();
      });
  }

  // --- On Destroy ---

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  get dateError(): boolean {
    const date = this.dateForm.get('date');

    const hasRequiredError = date?.hasError('required');
    const isTouched = date?.touched;

    return !!(hasRequiredError && isTouched);
  }
}
